<p-toast></p-toast>
<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons" *ngIf="dataLoaded">{{data.title}}</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationModel" *ngIf="validationModel.validationResults.length > 0"></validation-results>
    <div class="spinner" *ngIf="!dataLoaded"></div>
    <ng-container *ngIf="dataLoaded">
        <vehicle-add (onValidationErrors)="onValidationErrors($event)" [(vehicle)]="vehicle" [canAddNotes]="false" [displayBrands]="false" [searchString]="searchString"></vehicle-add>
    </ng-container>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()" [disabled]="isVehicleAdded">Cancel</button>
        <button class="btn--primary" type="submit" (click)="saveVehicle()" [disabled]="isVehicleAdded" *ngIf="!showLaunchUpdateRegistration">Save</button>
        <button class="btn--primary" type="submit" (click)="launchCorrectTitle()" *ngIf="showLaunchUpdateRegistration">Launch Update Registration</button>
    </div>
</div>